
export enum EnumOrigemLancamentoFinanceiro {
  Financeiro = 1,
  Movimento = 2,
  ItemMovimento = 3
}


